import React from "react";
import { useLocation, useNavigate } from "react-router";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import AddIcon from "@mui/icons-material/Add";

import { usePermissions } from "../../../contexts/permissions";
import useIsOrderDisabled from "../../../hooks/useIsOrderDisabled";
import InventoryItemModal from "./InventoryItemModal";
import {
  closeAddMoreItemsModal,
  isAddMoreItemsOpen,
  openAddMoreItemsModal,
} from "../../shopping/Cart/addMoreItemsRoute";

export default function AddAsset({ values, refetch, onItemAdded, processNewItem, projectId }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = usePermissions();
  const disabled = useIsOrderDisabled(values, user.company.settings.cut_off);
  const open = isAddMoreItemsOpen(location.search);

  const handleOpen = () => {
    openAddMoreItemsModal({ location, navigate, projectId });
  };

  const handleClose = () => {
    closeAddMoreItemsModal({ location, navigate });
    if (refetch) {
      refetch();
    }
  };

  return (
    <>
      <Box mt={2}>
        <Button disabled={disabled} variant="outlined" onClick={handleOpen}>
          Add More Items
          <AddIcon color={disabled ? "disabled" : "primary"} fontSize="small" />
        </Button>
      </Box>
      {open && (
        <InventoryItemModal
          projectId={projectId}
          onClose={handleClose}
          onItemAdded={onItemAdded}
          processNewItem={processNewItem}
        />
      )}
    </>
  );
}
